import { cn } from '@/lib/utils';
import { Building2, Store, MapPin } from 'lucide-react';

type WarehouseType = 'HUB' | 'SPOKE' | 'VENUE';

interface WarehouseTypeBadgeProps {
  type: WarehouseType;
  showIcon?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const typeStyles: Record<WarehouseType, string> = {
  HUB: 'bg-blue-100 text-blue-800',
  SPOKE: 'bg-purple-100 text-purple-800',
  VENUE: 'bg-amber-100 text-amber-800',
};

const sizeStyles = {
  sm: 'px-1.5 py-0.5 text-xs',
  md: 'px-2 py-0.5 text-xs',
  lg: 'px-2.5 py-1 text-sm',
};

const iconSizes = {
  sm: 'h-3 w-3',
  md: 'h-3.5 w-3.5',
  lg: 'h-4 w-4',
};

const typeIcons: Record<WarehouseType, typeof Building2> = {
  HUB: Building2,
  SPOKE: Store,
  VENUE: MapPin,
};

export function WarehouseTypeBadge({
  type,
  showIcon = true,
  size = 'md',
  className,
}: WarehouseTypeBadgeProps) {
  const Icon = typeIcons[type];

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full font-medium',
        typeStyles[type],
        sizeStyles[size],
        className
      )}
    >
      {showIcon && <Icon className={iconSizes[size]} />}
      {type}
    </span>
  );
}

export default WarehouseTypeBadge;
